export default __webpack_public_path__ + "static/media/support.c0b9cb82.svg";